<template>
  <div class="acmper">
    <div style="margin-bottom: 10px;">
      <button
        class="buto"
        @click="$router.back()"
      >返回</button>
      <van-search
        style="padding:0;display: inline-block;"
        v-model.trim="seachValue"
        placeholder="请输入营员姓名"
      />
    </div>

    <div>

      <div
        v-for="(item,index) in List"
        :key="index"
        class="css-display"
      >
        <!-- <div style="text-align: center;font-size: 20px;font-weight: 700;padding: 0 10px;background-color:#ffffff;">
          {{item.party_title}}
        </div> -->
        <div class="p10-size14">
          <div class="title-s">渠道</div>
          <div class="value-s">{{item.business_name}}</div>
        </div>
        <div class="p10-size14">
          <div class="title-s">孩子姓名</div>
          <div class="value-s">{{item.p_names}}</div>
        </div>
        <div class="p10-size14">
          <div class="title-s">报备时间</div>
          <div class="value-s">{{item.created_at}}</div>
        </div>
        <div class="p10-size14">
          <div class="title-s">状况</div>
          <div class="value-s">{{item.content}}</div>
        </div>

        <div>
          <button
            @click="seeMore(item.id)"
            class="buto"
            style="background-color:deepskyblue;"
          >点击查看</button>
        </div>

      </div>

    </div>

  </div>
</template>
<script>
import { Dialog, Toast } from 'vant'
export default {
  data() {
    return {
      seachValue: '',
      project_id: '',
      List: [],
    }
  },
  created() {
    this.project_id = this.$route.query.project_id
    this.seachValue = this.$route.query.seachValue || ''
    this.getInfo()
    this.$watch(
      'seachValue',
      this.$mUtil.debounce((newQuery) => {
        this.$axios
          .get('/project/issue-search', {
            params: {
              project_id: this.project_id,
              keyword: newQuery,
            },
          })
          .then((res) => {
            this.List = res.data.data.list
          })
      }, 1000)
    )
  },
  methods: {
    getInfo() {
      this.$axios
        .get('/project/issue-search', {
          params: {
            project_id: this.project_id,
            keyword: this.seachValue,
          },
        })
        .then((res) => {
          if (res.data.code == 400) {
            this.$router.replace({
              path: '/errorPage',
              query: { msg: res.data.msg },
            })
            return
          }
          this.List = res.data.data.list
        })
    },
    seeMore(id) {
      this.$router.push({
        path: 'abnormalDetail',
        query: {
          id: id,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.acmper {
  padding: 20px 20px;
  height: 100%;
}
.buto {
  vertical-align: top;
  background-color: #ee0a24;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
}
.css-display {
  background-color: #ffffff;
  color: #000000;
  border: 1px solid #f1f1f1;
  padding: 10px;
  font-size: 15px;
  border-radius: 10px;
  box-shadow: 2px 2px 4px rgba($color: #4c4d47, $alpha: 0.5);
  margin-bottom: 10px;
}

.p10-size14 {
  padding: 12px 15px;
  font-size: 14px;

  .title-s {
    display: inline-block;
    width: 35%;
    font-weight: 500;
    // color: brown;
    // text-align: center;
  }

  .value-s {
    display: inline-block;
    color: #999;
    width: 65%;
    text-align: right;
  }
}
</style>